import { useState, useEffect } from "react";
import { firestore } from "../firebase";
import { collection, getDocs } from "@firebase/firestore";

export default function useFileLoad(userID) {
  const [docs, setDocs] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadDocuments = async () => {
      try {
        setError("");
        const documents = [];
        const collectionRef = collection(
          firestore,
          "User",
          userID,
          "Documents"
        );
        const querySnapshot = await getDocs(collectionRef);
        querySnapshot.forEach((doc) => {
          let document = { ...doc.data() };
          document.id = doc.id;
          documents.push(document);
        });
        setDocs(documents);
      } catch (err) {
        setError("File Loading Error");
      }
    };
    loadDocuments();
  }, [userID]);

  return { docs, error };
}
